/** Add layers to the map
 */
import map from '../map';
import TileLayer from 'ol/layer/Tile.js';
import Stamen from 'ol/source/Stamen.js';
import OSM from 'ol/source/OSM';
import LayerGroup from 'ol/layer/Group'
import KML from 'ol/format/KML';
import VectorLayer from 'ol/layer/Vector';
import VectorSource from 'ol/source/Vector';
import BingMaps from 'ol/source/BingMaps';
//import Polygon from "ol/geom/Polygon";
import { fromExtent } from "ol/geom/Polygon";
import Feature from "ol/Feature";
import { Fill, Style} from 'ol/style';

/* Stamen layers*/ 
const watercolor = new TileLayer({
  title: 'Stamen-WaterColor',
  source: new Stamen({
    layer: 'watercolor'
  })
});

const labels = new TileLayer({
  title: 'Stamen-Labels',
  source: new Stamen({
    layer: 'terrain-labels'
  })
});
const stamen = new LayerGroup({ title: 'Stamen', layers: [watercolor, labels]});



  // A group layer for base layers
  var baseLayers = new LayerGroup({
    title: 'Base Layers',
    openInLayerSwitcher: false,
    layers: [
    
    new TileLayer({
      visible: true,
      title: 'bing',
      baseLayer: true,
      preload: Infinity,
      source: new BingMaps({
        key: 'AqDUp6regyH9TGtsZGVxrn0s0pA4tvV3hIoYPZf6tnMQMIvAzsn9IjisR48qbOfc',
        imagerySet: 'AerialWithLabelsOnDemand',
        // use maxZoom 19 to see stretched tiles instead of the BingMaps
        // "no photos at this zoom level" tiles
        // maxZoom: 19
      }),
    }),
      new TileLayer({
        title: "OSM",
        baseLayer: true,
        source: new OSM(),
        visible: false
      }),

//      new ol.layer.Tile({
//        title: "Watercolor",
//        baseLayer: true,
//        source: new ol.source.Stamen({ layer: 'watercolor' })
//      }),
//      new ol.layer.Tile({
//        title: "Toner",
//        baseLayer: true,
//        visible: false,
//        source: new ol.source.Stamen({ layer: 'toner' })
//      })    
    ]
  });

// Add a screen layer for varying opacity
//var polygon=new Polygon(map.getView().getProjection().getExtent());
var polygon = fromExtent(map.getView().getProjection().getExtent());
var feature = new Feature({geometry: polygon});

var screenLayer = new VectorLayer({
        title: "Screen",
  //background: 'red',
  style: new Style({
    fill: new Fill({
      color: "rgba(0, 0, 0,1 )"
    })
  }),
  source: new VectorSource({
  	features: [feature],
  }),
	opacity:0,
});


/* Add to map */
map.addLayer(baseLayers);
//map.addLayer(bing,osm);
//map.addLayer(osm);
//map.addLayer(bing);
//map.addLayer(stamen);
map.addLayer(screenLayer); // higher z-index

export {osm, stamen, labels, watercolor}
//export {osm}
